export { AddWelcomeMenuCancelPromptComponent } from './add-welcome-menu-cancel-prompt/add-welcome-menu-cancel-prompt.component';
